import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import { Collapse, Nav, NavItem, NavLink as BootstrapNavLink } from 'reactstrap';
import AppContext from '../../context/Context';
import NavbarVerticalMenuItem from './NavbarVerticalMenuItem';

const NavbarVerticalMenu = ({ routes, location }) => {
  const [openedIndex, setOpenedIndex] = useState(null);
  const [openedSubMsft, setOpenedSubMsft] = useState('');

  const { setShowBurgerMenu } = useContext(AppContext);
  // Only add one msft parent
  // let msftParentAdded = false;
  useEffect(() => {
    let openedDropdown = null;
    routes.forEach((route, index) => {
      if (location.pathname.indexOf(route.to) === 0) openedDropdown = index;
    });

    setOpenedIndex(openedDropdown);
    // eslint-disable-next-line
  }, []);

  const toggleOpened = (e, index) => {
    e.preventDefault();
    return setOpenedIndex(openedIndex === index ? null : index);
  };

  //----------------------------------------
  // Removed hr over Documentation menu item
  //----------------------------------------
  const getHr = name => {
    if (name === 'Widgets' || name === 'Documentation') {
      return (
        <></>
        // <div className="navbar-vertical-divider">
        //   <hr className="navbar-vertical-hr my-2" />
        // </div>
      );
    }
  };

  const msfts = routes.filter(
    r =>
      r.name === ' 365' ||
      r.name === 'Azure' ||
      r.name === ' Access' ||
      r.name === ' SQL Server' ||
      r.name === ' Windows Server'
  );

  return routes.map((route, index) => {
    if (!route.children) {
      return (
        <div key={route.name + '-key'}>
          {getHr(route.name)}
          <NavItem>
            <NavLink
              className="nav-link"
              data-testid={route.name + '-nav-link'}
              {...route}
              onClick={() => setShowBurgerMenu(false)}
            >
              <NavbarVerticalMenuItem route={route} />
            </NavLink>
          </NavItem>
        </div>
      );
    }
    // ------------------------------------
    // Separate nesting for MSFT subvendors
    // ------------------------------------
    if (route.name === ' 365') {
      return (
        <div key={'msft365-key'}>
          <NavItem>
            <BootstrapNavLink
              onClick={e => toggleOpened(e, 'msft')}
              className="dropdown-indicator cursor-pointer"
              aria-expanded={openedIndex === 'msft'}
              data-testid={route.name + '-nav-link'}
            >
              <div>
                <span className="nav-link-text">Microsoft</span>
              </div>
            </BootstrapNavLink>
            <Collapse isOpen={openedIndex === 'msft'}>
              <Nav>
                {msfts.map(m => {
                  return (
                    <div key={m.name + '-key'}>
                      <BootstrapNavLink
                        onClick={e => setOpenedSubMsft(openedSubMsft === m.name ? null : m.name)}
                        className="dropdown-indicator cursor-pointer ml-3"
                        aria-expanded={openedSubMsft === m.name}
                        data-testid={m.name + '-nav-link'}
                      >
                        <NavbarVerticalMenuItem route={m} />
                      </BootstrapNavLink>
                      <Collapse isOpen={openedSubMsft === m.name}>
                        <Nav>
                          <NavbarVerticalMenu routes={m.children} location={location} />
                        </Nav>
                      </Collapse>
                    </div>
                  );
                  // return <NavbarVerticalMenu key={index + m.name} routes={m.children} location={location} />;
                })}
              </Nav>
            </Collapse>
          </NavItem>
        </div>
      );
    }
    if (
      route.name === 'Azure' ||
      // route.name === 'Microsoft 365' ||
      route.name === ' Access' ||
      route.name === ' SQL Server' ||
      route.name === ' Windows Server'
    )
      return <></>;
    return (
      <div key={route.name + '--key'}>
        {getHr(route.name)}
        <NavItem>
          <BootstrapNavLink
            onClick={e => toggleOpened(e, index)}
            className="dropdown-indicator cursor-pointer"
            aria-expanded={openedIndex === index}
            data-testid={route.name + '-nav-link'}
          >
            <NavbarVerticalMenuItem route={route} />
          </BootstrapNavLink>
          <Collapse isOpen={openedIndex === index}>
            <Nav>
              <NavbarVerticalMenu routes={route.children} location={location} />
            </Nav>
          </Collapse>
        </NavItem>
      </div>
    );
  });
};

NavbarVerticalMenu.propTypes = {
  routes: PropTypes.array.isRequired,
  location: PropTypes.object.isRequired
};

export default withRouter(NavbarVerticalMenu);
